import React from 'react';
import PropTypes from 'prop-types';
import { PropType as PolygotPropType } from 'redux-polyglot';
// import moment from 'moment-timezone';
import { Skeleton, Alert } from 'antd';
import LocationOccupancyProvider from 'components/Providers/LocationOccupancyProvider';
import SplitBar from '../../../../Charts/SplitBar';

const OverCapacityBar = (props) => {
  const {
    p, result, fetching, failed, error,
    lounges, zones,
  } = props;

  if (fetching) {
    return <Skeleton active />;
  }
  if (failed || error) {
    return <Alert message={p.t('errors.loading', { error })} type="error" />;
  }
  let sortedData = [];
  const dataSet = new Set();
  let data = [];
  let maxCapacity = 100;
  const defaultZones = zones.filter(x => x.default_zone).map(x => x.id);
  // let xfmt = (x => moment(x).format('MM/DD'));
  sortedData = result.content.rows
    ? [...result.content.rows].sort((a, b) => a[0] - b[0]) : [];
  sortedData.forEach((arr) => {
    if (defaultZones.includes(arr[0])) {
      // eslint-disable-next-line max-len
      maxCapacity = (zones.filter(x => x.id === arr[0])[0] !== null && zones.filter(x => x.id === arr[0])[0] !== undefined) ? zones.filter(x => x.id === arr[0])[0].max_capacity : maxCapacity;
      if (arr[2] > maxCapacity) {
        if (dataSet.has((lounges[arr[0]]))) {
          data[data.length - 1][1] += 1;
        } else {
          dataSet.add(lounges[arr[0]]);
          data = [...data, ([lounges[arr[0]], 1])];
        }
      }
    }
  });
  // if (dimension === 'day') {
  //   sortedData.forEach((arr) => {
  //     if (dataSet.has((arr[0]))) {
  //       data[data.length - 1][1] += arr[2];
  //     } else {
  //       dataSet.add(xfmt(arr[1]));
  //       data.push([xfmt(arr[1]), arr[2]]);
  //     }
  //   });
  // } else if (dimension === 'hour') {
  //   xfmt = (x => moment(x).format('hA'));
  //   new Array(24).fill().forEach((_, i) => {
  //     data = [...data, [xfmt({ hour: i }), 0]];
  //   });
  //   sortedData.forEach((arr) => {
  //     const i = data.findIndex(x => x[0] === xfmt(arr[1]));
  //     data[i][1] += arr[2];
  //   });
  // }
  const colors = ['#f32f00'];

  return (
    <>
      <div className="british-airways-entries-by-lounge" style={{ minHeight: 315 }}>
        <SplitBar data={data} firstBarTitle={p.tt('minutes')} unit="m" singleBar colors={colors} maxWidth={60} />
      </div>
    </>
  );
};

OverCapacityBar.propTypes = {
  p: PolygotPropType,
  result: PropTypes.object,
  error: PropTypes.any,
  fetching: PropTypes.bool,
  failed: PropTypes.bool,
  lounges: PropTypes.object,
  zones: PropTypes.array,
};

export default LocationOccupancyProvider(({
  locationId,
  startDate,
  endDate,
}) => ({
  name: 'british_airways_over_capacity_time',
  endpoint: 'occupancy',
  metrics: 'occupancy',
  locationId,
  startTime: startDate,
  endTime: endDate,
  dimensions: 'minute',
}))(OverCapacityBar);
